import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { authApi } from "auth/api/authApi";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { isDevelopment } from "utils";

import errorReducer from "./errorSlice";
import { errorToastMiddleware } from "./middleware";

const persistConfig = {
    key: "rootContainer",
    storage,
};

const rootReducer = combineReducers({
    error: errorReducer,
    [authApi.reducerPath]: authApi.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const createStore = () => {
    return configureStore({
        reducer: persistedReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                immutableCheck: false,
                serializableCheck: false,
            })
                .concat(errorToastMiddleware)
                .concat(authApi.middleware),
        devTools: isDevelopment(),
    });
};
export const store = createStore();
export const persistor = persistStore(store);

export type StoreDispatch = typeof store.dispatch;
export type StoreState = ReturnType<typeof store.getState>;
